import { IonButton, IonSpinner } from "@ionic/react";
import { useState } from "react";
import "./ReloadDataBtn.css";

const ReloadDataBtn = ({ handleClick }: { handleClick: () => Promise<void> }) => {
  const [loading, setLoading] = useState(false);

  return (
    <IonButton
      id="reloadBtn"
      onClick={async () => {
        setLoading(true);
        await handleClick();
        setLoading(false);
      }}
    >
      {loading ? <IonSpinner id="reloadSpinner" /> : "Reload data"}
    </IonButton>
  );
};

export default ReloadDataBtn;
